import tippy from 'tippy.js'

document.addEventListener('turbo:load', (): void => {
  tippy('[data-tippy-content]')
})
